import { useContext, useState } from 'react'
import { TelemetryDataContext } from '../context/TelemetryDataContext'
import ConversationsModal from './ConversationsModal'

// showAll: the "See All Conversations" button and its modal, which work on one session (its
// SessionDataContext) - off where the conversations come from several (the experiment Overview).
// formatText: how a question's text is shown - as written, unless given one (the experiment
// Overview's word filter).
export default function LatestConversation({ students = [], showAll = true, formatText = (text) => text }) {
  const { stats } = useContext(TelemetryDataContext)
  const [showModal, setShowModal] = useState(false)

  const conversations = stats?.latestConversations
  const totalConversations = conversations?.totalConversations ?? '—'
  const uniqueConversations = conversations?.uniqueConversations ?? '—'
  const recentMessages = (conversations?.recentMessages ?? []).filter(m => m.type === 'query')

  return (
    <div className="latest-conversation">
      <h2>Latest Conversations</h2>
      <div className="conversation-stats">
        <div className="stat-row">
          <span className="stat-label">Total Conversations:</span>
          <span className="stat-value">{totalConversations}</span>
        </div>
        <div className="stat-row">
          <span className="stat-label">Unique Conversations:</span>
          <span className="stat-value">{uniqueConversations}</span>
        </div>
      </div>
      <div className="conversation-list">
        {recentMessages.length > 0 ? (
          recentMessages.map((message, index) => (
            <div key={index} className="conversation-item">
              <div className="conversation-message">{formatText(message.content)}</div>
              <div className="conversation-count">
                {new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
          ))
        ) : (
          <div className="no-conversations" style={{ 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100%' 
          }}>
            No conversations yet
          </div>
        )}
      </div>
      {showAll && (
        <>
          <button className="see-all-button" onClick={() => setShowModal(true)}>
            See All Conversations
          </button>

          <ConversationsModal
            open={showModal}
            onClose={() => setShowModal(false)}
            students={students}
          />
        </>
      )}
    </div>
  )
}